import './GenerateReportPage.css';

import React, { useState } from 'react';
import Banner from '../../b2b-common/Banner';
import PlanSelection from '../../b2b-plans/components/plans/PlanSelection';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import B2BStepper from '../../b2b-common/B2BStepper';
import PdfReportTypeSelection from '../components/pdfs/PdfReportTypeSelection';
import { useLoginContext } from '../../../App';
import { generatePdfReport } from '../../../services/b2b-reporting-apiServices';
import { CircularProgress } from '@mui/material';

const GenerateReportPage = () => {

    const { t } = useB2BTranslation('b2b-reporting');
    const { loginData } = useLoginContext();

    const [selectedPlan, setSelectedPlan] = useState(null);
    const [selectedReportType, setSelectedReportType] = useState(null);
    const [currentStep, setCurrentStep] = useState(0);
    const [stepperKey, setStepperKey] = useState(0);
    const [fetchingPdf, setFetchingPdf] = useState(false);

    const handlePlanSelected = (plan) => {
        setSelectedPlan(plan);
        // console.log('Selected plan:', plan);
    }

    const handleReportTypeSelected = (reportType) => {
        setSelectedReportType(reportType);
        // console.log('Selected report type:', reportType);
    }

    const steps = [
        {
            label: t('Select Plan'),
            description: t('Select the plan you want to generate a report for.'),
            content: (
                <PlanSelection
                    plansPerPage={6}
                    selectedPlanUUID={selectedPlan ? selectedPlan.planUUID : null}
                    onPlanSelected={handlePlanSelected}
                />
            ),
            disableNext: !selectedPlan,
        },
        {
            label: t('Select Report Type'),
            description: `${t('Select the type of report you want to generate for: ') + selectedPlan?.planName}`,
            content: (<PdfReportTypeSelection onSelection={handleReportTypeSelected} />),
            disableNext: !selectedReportType,
        },
    ];

    const handleCreateReport = async () => {
        try {
            setFetchingPdf(true);
            await generatePdfReport(loginData.accessToken, selectedReportType, selectedPlan.planUUID);
            setSelectedPlan(null);
            setCurrentStep(0);
            setStepperKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error('Error generating PDF report:', error.message);
        } finally {
            setFetchingPdf(false);
        }
    }

    const handleCancelReport = () => {
        console.log('Canceling report creation');
        setSelectedPlan(null);
        setStepperKey(prevKey => prevKey + 1);
    }

    return (
        <div className="generate-report-page">
            <Banner headingLevel='h1' message={t('Create Report')} underline={false} />
            {fetchingPdf ? (
                <div className="generate-report-loading-spinner">
                    <CircularProgress disableShrink />
                    <p className="generate-report-loading-spinner-text">{t('Wait while the PDF is being generated...')}</p>
                </div>
            ) : (
                <B2BStepper
                    key={stepperKey}
                    steps={steps}
                    className={'generate-report-stepper'}
                    onSuccess={handleCreateReport}
                    onCancel={handleCancelReport}
                    currentStep={currentStep}
                />
            )}
        </div>
    );
};

export default GenerateReportPage;